<template>
	<li>
		<div :class="{ nodeUnavailable : ( model._unavailable === true ) }">
			<router-link :class="{ bold: model.isHome }" :to="{ name : 'node', params : { nodeId : model.$id } }">{{model.$id}}</router-link>
			<span style="user-select: none;" @click.prevent="toggle" v-if="isFolder">[{{ open ? '-' : '+' }}]</span>
			<em v-if="model.isHome" @click.prevent="">(Home)</em>
			<em v-if="model._unavailable" @click.prevent="">(UNAVAILABLE)</em>
			<em v-if="model.tunnel" @click.prevent="">(via Tunnel)</em>
		</div>
		<ul v-show="open" v-if="isFolder">
			<node-tree-item class="item" v-for="(model, index) in model.children" :key="index" :model="model"></node-tree-item>
			<!--<li class="add" @click.prevent="addChild">+</li>-->
		</ul>
	</li>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import NodeTreeItem from "@/components/utilities/NodeTreeItem";
import Vue from 'vue';

export default {
	name: "node-tree-item",
	props: [],
	data() {
		return {
			nodeHierarchy
		};
	},
	components: { NodeTreeItem },
	props: {
		model: Object
	},
	data: function() {
		return {
			open: true
		};
	},
	computed: {
		isFolder: function() {
			return this.model.children && this.model.children.length;
		}
	},
	methods: {
		toggle: function() {
			if (this.isFolder) {
				this.open = !this.open;
			}
		},
		changeType: function() {
			if (!this.isFolder) {
				Vue.set(this.model, "children", []);
				this.addChild();
				this.open = true;
			}
		},
		addChild: function() {
			this.model.children.push({
				name: "new stuff"
			});
		}
	}
};
</script>
<style scoped>
.bold {
	font-weight: bold;
}
.nodeUnavailable a {
	text-decoration: line-through;
	color: #e00;
}
em {
	color: #e66;
}
</style>



// WEBPACK FOOTER //
// src/components/utilities/NodeTreeItem.vue